//es6引用机制 https://github.com/YvetteLau/Step-By-Step/issues/43
export let env = ''
export const setEnv = v => env = v

export const ATPrefix = {
  'uat': 'uat_',
  null: 'uat_',
  '': 'uat_',
  undefined: 'uat_',
  'preprod': 'preprod_',
  'prod': ''
}

export const getAccessTokenKey = () => `${ATPrefix[env]}access_token`

export const envFlag4Url = {
  'uat': '.uat',
  null: '.uat',
  '': '.uat',
  undefined: '.uat',
  'preprod': '.preprod',
  'prod': ''
}

export const getBaseUrl = () => `https://api${envFlag4Url[env]}.yiwoaikeji.com/`

export let accessToken = ''
export const setAccessToken = token => accessToken = token
export const getAccessToken = () => accessToken

export let canteenId = null
export const setCanteenId = id => canteenId = id
export const getCanteenId = () => canteenId

